import WMask from './mask';

WMask.install = (Vue) => {
  Vue.component(WMask.name, WMask);
};

export default WMask;
